import { render } from "./PublicationMenu.vue?vue&type=template&id=d4489d12&scoped=true"
import script from "./PublicationMenu.vue?vue&type=script&lang=js"
export * from "./PublicationMenu.vue?vue&type=script&lang=js"

import "./PublicationMenu.vue?vue&type=style&index=0&id=d4489d12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4489d12"

export default script